import { useEffect, useMemo } from 'react'
import { useTreeContext } from '../TreeProvider'
import { checkInPerimeter } from '../utils'

const TriggerSelection = ({tree, onFinish = () => {}}) => {
  const { selection, accounts, treeRef } = useTreeContext()

  useEffect(() => {
    if (treeRef.current) {
      checkInPerimeter({ accounts: selection }).filter(({in_perimeter}) => in_perimeter).forEach(({sf_id}) => {
        treeRef.current.get(sf_id)?.selectMulti()
      })
      onFinish()
    }
  }, [tree, selection, treeRef])
}

export default TriggerSelection
